import axios from "@/plugins/axios";

let url = "/api/v1/shop/reviews";

export default {
    getReviews(data){
        return axios.get(url, data).then(result => result.data);
    }
}
